import React from "react";
import { cn } from "../utils/cn";

/**
 * Consistent status pill. Replaces the ad-hoc ternary colour chains that were
 * duplicated in ActivityTable, ActivityModal and PaymentTable.
 */
const STATUS_STYLES: Record<string, string> = {
  COMPLETED: "bg-success/10 text-success ring-success/20",
  SUCCESS: "bg-success/10 text-success ring-success/20",
  LIVE: "bg-success/10 text-success ring-success/20",
  // Business verification states, as set by the admin app.
  APPROVED: "bg-success/10 text-success ring-success/20",
  VERIFIED: "bg-success/10 text-success ring-success/20",
  PENDING: "bg-[#CB9200]/10 text-[#CB9200] ring-[#CB9200]/20",
  "IN PROGRESS": "bg-primary/10 text-primary ring-primary/20",
  PROCESSING: "bg-primary/10 text-primary ring-primary/20",
  FAILED: "bg-destructive/10 text-destructive ring-destructive/20",
  REJECTED: "bg-destructive/10 text-destructive ring-destructive/20",
  CANCELLED: "bg-muted text-muted-foreground ring-border",
};

const StatusBadge = ({
  status,
  className,
}: {
  status?: string;
  className?: string;
}) => {
  const key = (status ?? "").toUpperCase();
  const style = STATUS_STYLES[key] ?? "bg-muted text-muted-foreground ring-border";

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide ring-1 ring-inset",
        style,
        className
      )}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {status || "—"}
    </span>
  );
};

export default StatusBadge;
